import styled from 'styled-components';

export const Input = styled.input`
  width: ${({ width }) => width}px;
`;

export const WidthProxySpan = styled.span`
  display: inline-block;
  position: absolute;
  visibility: hidden;
  white-space: pre;
`;
